import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';

import { getTranslatedString } from 'helpers/i18n';
import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import OutlinedSelect from 'helpers/reduxFormMaterialUiNext/OutlinedSelect';

import MenuItem from '@material-ui/core/MenuItem';

import RenderDropzoneMultiFileInput from 'components/shared/RenderDropzoneMultiFileInput';

import * as validator from 'helpers/Validator';
import { featureEnabled } from 'helpers/ToggleBot';
import { getSuiteRooms, getTenantPortalRequestType } from 'helpers/SelectOptions';
import validate from 'components/tenant_application/validate';

let RFMForm = (props) => {
  const { handleSubmit, maintenanceCategories, maintenanceLocations } = props;

  const FILE_FIELD_NAME = 'files';
  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-sm-6" style={{ marginTop: '15px' }}>
          <Field
            name="category"
            component={OutlinedSelect}
            validate={[validator.required]}
            fullWidth
            variant="outlined"
            aria-label={getTranslatedString('RFM.category')}
            label={getTranslatedString('RFM.category')}
          >
            {maintenanceCategories.map((category) => (
              <MenuItem value={category.value} key={category.label}>
                {category.label}
              </MenuItem>
            ))}
          </Field>
        </div>
        <div className="col-sm-6" style={{ marginTop: '15px' }}>
          <Field
            name="suite_location"
            component={OutlinedSelect}
            validate={[validator.required]}
            fullWidth
            variant="outlined"
            aria-label={getTranslatedString('RFM.suite_location')}
            label={getTranslatedString('RFM.suite_location')}
          >
            {_renderSuiteLocations(maintenanceLocations, props.tenancyInfo.property_type)}
          </Field>
        </div>
      </div>

      <div className="row" style={{ marginTop: '35px' }}>
        <div className="col-xs-12">
          <label style={{ width: '100%' }} aria-label={getTranslatedString('RFM.subject')}>
            <Field
              name="subject"
              validate={[validator.required]}
              component={TextField}
              fullWidth
              style={{ marginTop: '-21px', fontSize: '15px' }}
              variant="outlined"
              label={getTranslatedString('RFM.subject')}
              aria-label={getTranslatedString('RFM.subject')}
            />
          </label>
        </div>
        <div className="col-xs-12" style={{ marginTop: '30px' }}>
          <label style={{ width: '100%' }} aria-label={getTranslatedString('RFM.description')}>
            <Field
              name="ticket_description"
              component={TextField}
              validate={[validator.required]}
              label={getTranslatedString('RFM.description')}
              aria-label={getTranslatedString('RFM.description')}
              multiline
              fullWidth
              rows={2}
              style={{ marginTop: '-15px', fontSize: '15px' }}
              variant="outlined"
            />
          </label>
        </div>
      </div>

      <div className="row" style={{ marginTop: '15px' }}>
        <div className="col-xs-12">
          <Field
            name="request_type"
            component={OutlinedSelect}
            validate={[validator.required]}
            fullWidth
            variant="outlined"
            aria-label={getTranslatedString('RFM.request_type')}
            label={getTranslatedString('RFM.request_type')}
          >
            {getTenantPortalRequestType().map((request_type) => {
              return (
                <MenuItem value={request_type.value} key={getTranslatedString(request_type.label)}>
                  {getTranslatedString(request_type.label)}
                </MenuItem>
              );
            })}
          </Field>
        </div>
        <div className="col-xs-12" style={{ marginTop: '15px' }}>
          <label style={{ width: '100%' }} aria-label={getTranslatedString('RFM.tenant_note')}>
            <Field
              name="tenant_note"
              component={TextField}
              hintText={getTranslatedString('portal.serviceRequestDescriptor.visibleToLandlord')}
              hintStyle={{ fontSize: '15px' }}
              rows={4}
              aria-label={getTranslatedString('RFM.additional_information')}
              multiline
              fullWidth
              variant="outlined"
              label={getTranslatedString('RFM.additional_information')}
            />
          </label>
        </div>
      </div>

      <div className="row" style={{ padding: '15px' }}>
        <Field
          tabIndex="0"
          name={FILE_FIELD_NAME}
          component={RenderDropzoneMultiFileInput}
          acceptedFileTypes=".jpeg, .png, .jpg, .pdf"
        />
      </div>
    </form>
  );
};

const _renderSuiteLocations = (maintenanceLocations, propertyType) => {
  if (featureEnabled('maintenance.dynamic_locations')) {
    return maintenanceLocations.map((room) => (
      <MenuItem
        value={room.value}
        key={room.label}
        label={room.label}
        style={{ textTransform: 'none' }}
      >
        {room.label}
      </MenuItem>
    ));
  }

  return getSuiteRooms(true, propertyType).map((room) => (
    <MenuItem
      value={room.value}
      key={getTranslatedString(room.label)}
      style={{ textTransform: 'none' }}
    >
      {getTranslatedString(room.label)}
    </MenuItem>
  ));
};

RFMForm = reduxForm({
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
  validate,
})(RFMForm);

RFMForm = connect((state, ownProps) => {
  const selector = formValueSelector(ownProps.formName);
  const assignValue = selector(state, 'assign');
  const messageToTenant = selector(state, 'message_to_tenant');
  const unitAndProperty = [selector(state, 'unit'), selector(state, 'property')];
  return {
    assignValue,
    messageToTenant,
    unitAndProperty,
    initialValues: {
      request_type: 'Portal Request - Maintenance',
    },
    form: ownProps.formName,
  };
})(RFMForm);

export default RFMForm;
